import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import { CodeBlock, BlockType, Define } from '@appblocks/codegeneration/types';

export default class Wln extends BaseFeature {
    constructor() {
        super();
        this.id = 'wln';
        this.name = 'Wireless';
        this.fileLinks = [
            // 'wln\\wln.tbs',
            // 'wln\\wln.tbh',
        ];
        this.files = [
            // 'libraries/wln/wln.tbh',
            // 'libraries/wln/wln.tbs',
        ];
    }

    getDefines(): Array<Define> {
        if (this.getEnabled()) {
            return [
                {
                    name: 'WLN_AVAILABLE',
                    value: '1',
                },
            ];
        }
        return [];
    }

    getCodeBlocks() {
        const blocks: Array<CodeBlock> = [];


        //         blocks.push({
        //             location: 'DEVICE_TBS',
        //             blockType: BlockType.LOCATION,
        //             id: 'callback_wln_failure',
        //             template: `
        // #if WLN_AVAILABLE
        // sub callback_wln_failure(wln_state as en_wln_status_codes)
        //     '****callback_wln_failure****'
        // end sub
        // #endif
        //         `,
        //         });

        //         blocks.push({
        //             location: 'DEVICE_TBS',
        //             blockType: BlockType.LOCATION,
        //             id: 'callback_wln_ok',
        //             template: `
        // sub callback_wln_ok()
        //     '****callback_wln_ok****'
        // end sub
        // `,
        //         });
        //         blocks.push({
        //             location: 'DEVICE_TBS',
        //             blockType: BlockType.LOCATION,
        //             id: 'callback_wln_starting_association',
        //             template: `
        // sub callback_wln_starting_association()
        //     '****callback_wln_starting_association****'
        // end sub
        //         `,
        //         });

        //         blocks.push({
        //             location: 'DEVICE_TBS',
        //             blockType: BlockType.LOCATION,
        //             id: 'callback_wln_pre_buffrq',
        //             template: `
        // sub callback_wln_pre_buffrq(required_buff_pages as byte)
        //     '****callback_wln_pre_buffrq****'
        // end sub
        //         `,
        //         });

        //         blocks.push({
        //             location: 'DEVICE_TBS',
        //             blockType: BlockType.LOCATION,
        //             id: 'callback_wln_mkey_progress_update',
        //             template: `
        // sub callback_wln_mkey_progress_update(progress as byte)
        //     '****callback_wln_mkey_progress_update****'
        // end sub
        //         `,
        //         });
        //         blocks.push({
        //             location: 'DEVICE_TBS',
        //             blockType: BlockType.LOCATION,
        //             id: 'callback_wln_rescan_result',
        //             template: `
        // sub callback_wln_rescan_result
        // (current_rssi as byte, scan_rssi as byte, different_ap as no_yes)
        //     '****callback_wln_rescan_result****'
        // end sub
        //         `,
        //         });

        //         blocks.push({
        //             location: 'DEVICE_TBS',
        //             blockType: BlockType.LOCATION,
        //             id: 'callback_wln_rescan_for_better_ap',
        //             template: `
        // sub callback_wln_rescan_for_better_ap()
        //     '****callback_wln_rescan_for_better_ap****'
        // end sub

        //             `,
        //         });

        return blocks;
    }
}
